import { Button } from '@calizahq/react-components-v2'
import { animated, config, useTransition } from '@react-spring/web'
import React, { useMemo } from 'react'

import { useAlertContext } from '@/context'
import { useMobile } from '@/hooks'
import { useGuardedNavigate } from '@/hooks/useGuardedNavigate'

const AnimatedDiv = animated.div as React.ComponentType<{ [key: string]: any }>

export const AlertPopup = () => {
  const { text, type, link } = useAlertContext()
  const navigate = useGuardedNavigate()
  const { isMobile } = useMobile()
  const isVisible = text && type

  const variantClassName = useMemo(() => {
    const t = type || 'info'
    return AlertVariantStyles[t]
  }, [type])
  const transition = useTransition(isVisible, {
    from: { y: 10, opacity: 0 },
    enter: { y: 0, opacity: 1 },
    leave: { y: 800, opacity: 0 },
    config: { ...config.stiff, clamp: true },
  })

  const handleLinkClick = () => {
    link && navigate(link)
  }

  return (
    <>
      {transition(
        (styles, item) =>
          item && (
            <AnimatedDiv
              className={`fixed z-50 max-w-screen rounded-md px-4 py-3 ${
                isMobile ? 'bottom-2 left-2' : 'bottom-6 left-1/2 text-p-md'
              } ${variantClassName}`}
              style={{
                ...styles,
              }}
            >
              <div className="flex w-full flex-col items-center md:flex-row">
                <p
                  className="mr-0 md:mr-4"
                  style={{
                    color: 'white',
                    display: 'block',
                    visibility: 'visible',
                    fontSize: '14px',
                    lineHeight: '1.5',
                  }}
                >
                  {text}
                </p>
                {link && (
                  <Button className="md:px-2 md:py-0" onClick={handleLinkClick} size="small" variant="tertiary">
                    View
                  </Button>
                )}
              </div>
            </AnimatedDiv>
          ),
      )}
    </>
  )
}

export const AlertVariantStyles = {
  success: 'bg-bg-accent-dark text-white',
  error: 'bg-red-300 text-white',
  info: 'bg-bg-page-info text-white',
  none: '',
}
